import React from 'react';
import { getStatusOpName, OP_STATUS } from '../../util/varibles/constants';
import styles from './style.module.scss';

interface IProps {
    visible?: boolean;
    className?: string;
    status: OP_STATUS;
}

const OperationStatus: React.FC<IProps> = ({
    visible = true,
    className = '',
    status,
}) => {
    if (!visible) return null;

    return (
        <div
            className={[styles['operation-status'], className].join(' ')}
            data-status={status}
        >
            {getStatusOpName(status)}
        </div>
    );
};

export default OperationStatus;